import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@construct-kit/core';
import styles from './AreaAndRegionSelector.scss';

const AreaAndRegionSelector = ({ items, currentAreaAndRegionItem, changeAreaAndRegion }) => (
  <div className={styles.container}>
    <Select
      id="areaAndRegionSelector"
      className="areaAndRegionSelector"
      hideLabel
      options={items}
      label="Area and region"
      placeholder="All States"
      onSelectedOptionChange={({ value: { areaId, regionId } }) =>
        changeAreaAndRegion(areaId, regionId)
      }
      defaultSelectedOptions={[currentAreaAndRegionItem]}
    />
  </div>
);

const MOBILE_ITEM_PROP_TYPE = PropTypes.shape({
  displayText: PropTypes.string.isRequired,
  value: PropTypes.shape({
    areaId: PropTypes.string.isRequired,
    regionId: PropTypes.string.isRequired,
  }).isRequired,
});

AreaAndRegionSelector.propTypes = {
  items: PropTypes.arrayOf(MOBILE_ITEM_PROP_TYPE.isRequired).isRequired,
  currentAreaAndRegionItem: MOBILE_ITEM_PROP_TYPE.isRequired,
  changeAreaAndRegion: PropTypes.func.isRequired,
};

export default AreaAndRegionSelector;
